export default "__VITE_ASSET__Dq4T_qud__"